import _ from 'lodash';
import { SgExperianService } from 'sg-capability-experian';
import CommonConstants from 'sg-common-constants';

function updateCueClaimsModel(modelVM, updateData, quoteData) {
    const respPhDriver = _.find(quoteData.lobData.privateMotor.coverables.spmDrivers, (driver) => driver.isPolicyHolder);
    const modelPhIndex = _.findIndex(modelVM.lobData.privateMotor.coverables.spmDrivers.value, { isPolicyHolder: true });
    const modelCopy = _.clone(modelVM);
    modelCopy.lobData.privateMotor.coverables.spmDrivers.value[modelPhIndex].cueClaims = respPhDriver.cueClaims;
    modelCopy.lobData.privateMotor.coverables.spmDrivers.value[modelPhIndex].dateOfLastSuccessfulCUECheck = respPhDriver.dateOfLastSuccessfulCUECheck;
    updateData(modelCopy);
}

async function getCueData(modelVM, updateData) {
    return new Promise((resolve) => {
        const modelPh = _.find(modelVM.lobData.privateMotor.coverables.spmDrivers.value, (driver) => driver.isPolicyHolder);
        if (!modelPh.dateOfLastSuccessfulCUECheck) {
            const modelCopy = _.clone(modelVM);
            updateData(modelCopy);
            SgExperianService.getCueData(modelVM.value).then((quoteData) => {
                updateCueClaimsModel(modelVM, updateData, quoteData);
            }).catch((err) => {
                if (_.get(err, 'baseError.error.data.appErrorCode') === CommonConstants.SG_ERROR_CODES.SAGA_SESSION_TIMEOUT) {
                    throw err;
                }
            }).finally(() => {
                resolve();
            });
        } else {
            resolve();
        }
    });
}

function shouldShowCuePage(modelVM) {
    const drivers = modelVM.lobData.privateMotor.coverables.spmDrivers;
    const policyHolderIndex = drivers.children.findIndex((driver) => driver.isPolicyHolder);
    return !!drivers.children[policyHolderIndex].cueClaims && drivers.children[policyHolderIndex].cueClaims.length > 0
        && !drivers.children[policyHolderIndex].cueClaims.aspects.subtreeValid;
}

export default {
    getCueData,
    shouldShowCuePage
};
